import { selectSelectedAppLocalizations } from "../../../../state/selectors";
import { getState } from "../../../../state/store";

const formatLanguageOptions = (options) => {
  return options
    .map((opt) => {
      return { ...opt, value: `${opt.id} - ${opt.value}` };
    });
};

const calculateMissingKeys = (defaultLangKeys = [], langData = []) => {
  const missing = defaultLangKeys.filter((key) => !langData.includes(key));

  return missing.reduce((acc, key) => {
    acc[key] = defaultLangKeys[key];
    return acc;
  }, {});
};

const validateName = (name) => {
  const appLocalizations = selectSelectedAppLocalizations()(getState());
  const names = appLocalizations
    .filter((localization) => !localization.isNew)
    .map((localization) => localization?.name?.toLowerCase());

  return name?.length && !names?.includes(name?.toLowerCase());
};

export const localisationTabUtils = {
  formatLanguageOptions,
  calculateMissingKeys,
  validateName
};
